$(document).ready(function() {
    if($('body').hasClass('innovation')){
        
        $('.follow.btn').click(function(){
            
        });
        
        $('.unfollow.btn').click(function(){
            
        });
    }
});